// import { identity } from "lodash";
import React from "react";

export const DailyLocomotiveSchema = [
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Top/Cab Inspection",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
      {
        title: "Inspected",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
      {
        title: "Ground/Bottom Inspection",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
      {
        title: "Inspected",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#1 §229.23 PERIODIC INSPECTION - Examine Form F6180.49A (Blue Card) to ensure all inspections & tests prescribed by Part 229 are current.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "23PI",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#13 §229.123 PILOTS, SNOWPLOWS, ENDPLATES - The end in the direction of travel of each lead locomotive must have a pilot plate or snow plow properly secured and be not less than 3 inches nor more than 6 inches from rail.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "123PSE",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#2 §229.119 CABS, FLOORS, PASSAGEWAYS - Determine that cab floors and passageways are free of impediments that might cause a tripping/slipping hazard. Cab seats must be properly secured to prevent personal injury.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "119CFP",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#14 §229.61 DRAFT SYSTEM - Couplers & uncoupling levers must function properly. Visually inspect the exposed components or the draft system for defects.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "61DS",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#3 §229.129 AUDIBLE WARNING DEVICE - Operate the horn on the leading locomotive to determine that it functions. When equipped, operate the bell.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "129AWD",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#15 §229.89 JUMPER CABLES - Jumper cables may not be broken, chafed, or left hanging with one end free. Jumper receptacles may not have broken terminals or retainer caps.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "89JC",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#4 §229.127 CAB LIGHTS - Cab overhead and instrument lights shall be operative and provide sufficient illumination. Passageways used by the crew shall also be illuminated.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "127CL",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#16 §229.131 SANDERS - Sanders must operate on each locomotive in front of the first powered wheel set in the direction of travel and must be aligned to deposit sand on the rail.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "131S",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#5 §229.117 SPEED INDICATORS - Inspect the speed indicator on the controlling locomotive to determine that it is not damaged. Tests shall be made to determine accuracy after departure.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "117SI",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#17 §229.125/133 HEADLIGHTS, AUX. LIGHTS - Headlights and dimmer switch must be operative for the lead end of road locomotives & both ends of locomotive in switching service. Aux. lights may not be used in lieu of headlight.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "125/133HAL",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#6 §229.46/47/49/53/59 BRAKE SYSTEMS - Locomotive brakes shall be known that they operate as intended. Test procedures should include the testing of automatic and independent brake valves. Drain water and oil from the reservoir.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "46/47/49/53/59BS",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#18 §229.55 PISTON TRAVEL - Piston travel must not exceed 1 1/2 inches less than the maximum total travel. Total possible piston travel can be acquired from the Blue Card, (F6180.49A). Released brakes shall provide brake shoe clearance.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "55PT",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#7 §229.13 CONTROL OF LOCOMOTIVE - Whenever two or more locomotives are coupled in remote or multiple control, all systems shall respond to control from the cab of the controlling locomotive. (i.e. propulsion, sanders, air brakes, etc.)",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "13COL",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#19 §229.57 FOUNDATION BRAKE GEAR - Inspect brake rigging to ensure that all parts are secured. Brake shoes must align correctly with the wheel and not be overlapped and grooved.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "57FBG",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#8 §229.41 PROTECTION PERSONAL INJURY - Exposed moving mechanical parts, relays, switches and high voltage equipment (inside cab & engine room compartment) shall not present undue safety hazards to crew members.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "41PRI",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#20 §229.75 WHEELS - Inspect wheels for the following conditions: Flat spot(s), High flange, Shelled spot(s), Thin flange, Thin rim, Gouge or chip in flange, Cracks or breaks in flange, rim, plate, or hub.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "75W",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#9 §229.43 EXHAUST & BATTERY GASES - Inspect for signs of diesel exhaust, battery gases or other noxious fumes are vented to the outside and not in the cab of the controlling locomotive.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "43EBG",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#21 §229.67/69/71 TRUCKS - Trucks may not be cracked or broken. Conduct walk-around inspection of exposed truck components for cracked, broken, or hazardous conditions. Inspect the underside from outside gauge of rail for defective components. No part except wheels and non-metallic sand hoses may be less than 2.5 inches from rail.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "67/69/71T",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#10 §229.101 ENGINES - Temperature and pressure alarms shall be observed to determine that the engine functions properly. A shut down engine shall be tagged with a warning notice.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "101E",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#22 §229.65 SPRING RIGGINGS - Truck springs and rigging must not be broken and be in proper position; and spring safety hangers to be in correct position. Shock absorbers may not be broken or leaking clearly formed droplets of oil or fluid.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "65SR",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title:
          "#11 §229.45 GENERAL CONDITION - Inspect to determine that no defects exists that would endanger the safety of the crew, such as insecure or improper function of components, safety appliances, structural defects, etc.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "45GC",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
      {
        title:
          "#23 §229.91 MOTORS & GENERATORS - No traction motor may be cut out. All traction motor cables and cable connections should be damage-free and free from accumulation of oil that may be a hazard.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "91MG",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "",
        colSpan: 12,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },

      {
        title:
          "#24 §229.64 PLAIN BEARING - Inspect plain bearing boxes for cracks or damage that might cause loss or contamination of lubricant.",
        colSpan: 10,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
        unBold: true,
      },
      {
        title: "YES",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "64PB",
        isValueOnly: true,
        unBold: true,
        formatter: (vals) => {
          return <span>{vals}</span>;
        },
      },
    ],
  },
];

export const RepairsHeader = [
  {
    heights: { header1: "80px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Repairs",
        colSpan: 8,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  },

  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Repaired Item",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
      {
        title: "Comments",
        colSpan: 5,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  },
];
export const DefectsHeader = [
  {
    heights: { header1: "80px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Defects",
        colSpan: 8,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Defected Item",
        colSpan: 3,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
      {
        title: "Comments",
        colSpan: 5,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  },
];

export const customHeader = [
  {
    heights: { header1: "50px" },
    classes: { header1: "" },
    inlineData: true,
    columns: [
      {
        title: "Line Name",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "lineName",
      },
      {
        title: "Asset Type",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "assetType",
      },
    ],
  },
  {
    heights: { header1: "50px" },
    classes: { header1: "" },
    inlineData: true,
    columns: [
      {
        title: "Date",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "date",
      },
      {
        title: "Asset Id",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "assetUnitId",
      },
    ],
  },
  {
    heights: { header1: "50px" },
    classes: { header1: "" },
    inlineData: true,
    columns: [
      {
        title: "User",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "userName",
      },
      {
        title: "Email",
        colSpan: 2,
        rowSpan: 1,
        leftAlign: true,
        className: "tbl-text-normal",
        accessor: "email",
      },
    ],
  },
];

export const customHeaderRows = [
  {
    heights: { header1: "60px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Line Name",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "lineName",
        formatter: (val) => <span style={{ fontSize: "x-large" }}>{val}</span>,
        titleFormatter: (val) => <span style={{ fontSize: "x-large", paddingInlineStart: "10px" }}>{val}</span>,
        // isTitleOnly: true,
      },
      {
        title: "Asset Type",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "assetType",
        formatter: (val) => <span style={{ fontSize: "x-large" }}>{val}</span>,
        titleFormatter: (val) => <span style={{ fontSize: "x-large", paddingInlineStart: "10px" }}>{val}</span>,
        // isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "60px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Date",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "date",
        formatter: (val) => <span style={{ fontSize: "x-large" }}>{val}</span>,
        titleFormatter: (val) => <span style={{ fontSize: "x-large", paddingInlineStart: "10px" }}>{val}</span>,
        // isTitleOnly: true,
      },
      {
        title: "Asset",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: ["assetUnitId"],
        formatter: (val) => {
          return <span style={{ fontSize: "x-large" }}>{val}</span>;
        },
        titleFormatter: (val) => {
          return <span style={{ fontSize: "x-large", paddingInlineStart: "10px" }}>{val}</span>;
        },
        // isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "60px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "User",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "userName",
        formatter: (val) => <span style={{ fontSize: "x-large" }}>{val}</span>,
        titleFormatter: (val) => <span style={{ fontSize: "x-large", paddingInlineStart: "10px" }}>{val}</span>,
        // isTitleOnly: true,
      },
      {
        title: "Email",
        colSpan: 1,
        leftAlign: true,
        rowSpan: 1,
        className: "heading-info",
        accessor: "email",
        formatter: (val) => <span style={{ fontSize: "x-large" }}>{val}</span>,
        titleFormatter: (val) => <span style={{ fontSize: "x-large", paddingInlineStart: "10px" }}>{val}</span>,
        // isTitleOnly: true,
      },
    ],
  },
];
export const MultipleAssetHeader = [
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Locomotives in MU",
        colSpan: 7,
        rowSpan: 1,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
    ],
  },
  {
    heights: { header1: "40px" },
    classes: { header2: "" },
    inlineData: true,
    columns: [
      {
        title: "Assets",
        colSpan: 2,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "",
        isTitleOnly: true,
      },
      {
        title: "Asset Name",
        colSpan: 5,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "data",
        isValueOnly: true,
      },
    ],
  },
];

export const TopInfoTableSection = [
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Engine Hours",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "engHour",
        isTitleOnly: true,
      },
      {
        title: "Engine Hour",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "engHour",
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Engine Oil Level",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "engineoillevel",
        isTitleOnly: true,
      },
      {
        title: "Engine Oil Level",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "engineoillevel",
        isValueOnly: true,
      },
    ],
  },
  {
    heights: {
      header1: "40px",
    },
    classes: {
      header2: "",
    },
    inlineData: true,
    columns: [
      {
        title: "Fuel Level (gallons)",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "fuelLevel",
        isTitleOnly: true,
      },
      {
        title: "Fuel Level (gallons)",
        colSpan: 1,
        rowSpan: 1,
        topAlign: true,
        className: "tbl-text-normal",
        accessor: "fuelLevel",
        isValueOnly: true,
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/components/Reports/ReVAMP/DailyLocomotiveInspection/DailyLocomotiveSchema.jsx